import moment from 'moment'
import { v4 as uuidv4 } from 'uuid';
import { getTimeString } from '../../util/datetime'


export const makeGoogleCalendarUrl = (event) => makeUrl('https://calendar.google.com/calendar/render', {
  action: 'TEMPLATE',
  dates: `${makeTime(event.startsAt)}/${makeTime(event.endsAt)}`,
  location: event.location,
  recur:event.rrule,
  text: event.name,
  details: event.details,
});

export const makeTime = (time) => new Date(time).toISOString().replace(/[-:]|\.\d{3}/g, '');

type Query = { [key: string]: null | boolean | number | string };

const makeUrl = (base, query) => Object.keys(query).reduce(
  (accum, key, index) => {
    const value = query[key];

    if (value !== null) {
      return `${accum}${index === 0 ? '?' : '&'}${key}=${encodeURIComponent(value)}`;
    }
    return accum;
  },
  base
);

export const mapToDays = (days) => {
    let mappedDays = (days.split(",")).map(item => {
        switch (item) {
            case "0": return "Sun";
            case "1": return "Mon";
            case "2": return "Tue";
            case "3": return "Wed";
            case "4": return "Thu";
            case "5": return "Fri";
            case "6": return "Sat";
        }
    })
    return mappedDays;
}

export const makeOutlookCalendarUrl = (event) => makeUrl('https://outlook.live.com/owa', {
  rru: 'addevent',
  startdt: event.startsAt,
  enddt: event.endsAt,
  subject: event.name,
  location: event.location,
  body: event.details,
  allday: false,
  repeat:event.rrule.split('RRULE:')[1],
  uid: new Date().getTime().toString(),
  path: '/calendar/view/Month',
});

export const makeICSCalendarUrl = (event) => {
  console.log(event)
  const components = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'BEGIN:VEVENT',
    `TZID:${Intl.DateTimeFormat().resolvedOptions().timeZone}`,
    `URL:${document.URL}`,
    `DTSTART:${makeTime(event.startsAt)}`,
    `DTEND:${makeTime(event.endsAt)}`,
    event.rrule || '',
    `SUMMARY:${event.name}`,
    `DESCRIPTION:${event.details}`,
    `LOCATION:${event.location}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ];

  return encodeURI(`data:text/calendar;charset=utf8,${components.join('\n')}`);
};


//end credit: //Credit: https://raw.githubusercontent.com/vborodulin/add-event-to-calendar/master/src/index.tsx